import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

import { getField, updateField } from 'vuex-map-fields';

const vuexPersist = new VuexPersist({
  key: 'surveyjs',
  storage: localStorage
})

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {

    answers: {
      // createdAt: null,
      seeking: [],
      favoriteMedia: [],
      firstTime: "",
      objective: "",
      technics: [],
      budget: "",
      when: "",
      timesPerWeek: '',
      operator: [],
      favoriteBets: "",
      name: "",
      firstname: "",
      email: "",
      continent_code: "",
      country_name: "",
      ip: "",
    }
  },
  mutations: {
    updateField,
    updateLocation(state, payload) {
      state.answers.ip = payload.ip
      state.answers.country_name = payload.country_name
      state.answers.continent_code = payload.continent_code
    }
  },
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
  },
  actions: {

  }
})
